import { LoadType } from '@paragon/contract-library';

export function getLoadTypeOption(loadType: LoadType) {
  return loadTypeOptions[loadType];
}

export type Option<T> = {
  name: string;
  value: T;
};

type LoadTypeOptions = {
  [key in LoadType]: Option<LoadType>;
};

const loadTypeOptions: LoadTypeOptions = {
  Dead: {
    name: 'Dead',
    value: 'Dead',
  },
  LiveRoof: {
    name: 'Roof Live',
    value: 'LiveRoof',
  },
  Wind: {
    name: 'Wind',
    value: 'Wind',
  },
  Tornado: {
    name: 'Tornado',
    value: 'Tornado',
  },
  Rain: {
    name: 'Rain',
    value: 'Rain',
  },
  Snow: {
    name: 'Snow',
    value: 'Snow',
  },
  LiveFloor: {
    name: 'Floor Live',
    value: 'LiveFloor',
  },
  Unknown: {
    name: 'Unknown',
    value: 'Unknown',
  },
  Drag: {
    name: 'Drag',
    value: 'Drag',
  },
  Seismic: {
    name: 'Seismic',
    value: 'Seismic',
  },
  Person: {
    name: 'Person',
    value: 'Person',
  },
};
